export const instruments =[
    "Guzheng",
    "Erhu",
    "Dizi",
    "Yangqin",
    "Pipa",
    "Ruan",
    "Liuqin",
    "Cello",
    "Double Bass",
    "Hulusi",
    "Guanzi",
    "Gaoyin Suona",
    "Zhongyin Suona (Grade 1 to 8 only)",
    "Percussion",
    "Guqin",
    "Gaoyin Sheng",
    "Zhongyin Sheng (Grade 1 to 8 only)"
];

export const grades =["Grade 1","Grade 2","Grade 3","Grade 4","Grade 5","Grade 6","Grade 7","Grade 8","Certificate In Professional Performance"]